import React from 'react';
import { Outlet } from 'react-router-dom';
import '../../assets/css/common.css';
import Header from './Header';
import Sidebar from './Sidebar';

const BluetoothLayout = () => {
  const bluetoothItems = [
      { to: '/bluetooth', label: '블루투스 데이터 수신' },
  ];

  return (
    <div className="wrap">
      <Header />
      <div className="section_area">
        <Sidebar items={bluetoothItems}/>
        <div className="section_wrap">
          <Outlet />
        </div>
      </div>
    </div>
  );
};

export default BluetoothLayout;
